<script setup lang="ts">
/** [#e03fdbc2] Раздел инструкций: полные руководства и короткие статьи по группам. */
import { computed } from 'vue';
import { ChevronRight } from 'lucide-vue-next';
import { ARTICLES } from '@/seo/head';
import { GUIDES } from '@/seo/guides';
import PublicShell from './landing/PublicShell.vue';
import { usePublicPage } from './landing/usePublicPage';

const { locale, copy, to } = usePublicPage();

const guides = computed(() => GUIDES.map((g) => ({ path: g.path, ...g.i18n[locale.value] })));
const groups = computed(() =>
  (['enrollment', 'station', 'backup'] as const).map((key) => ({
    key,
    title: copy.value.articles.groups[key],
    items: ARTICLES.filter((a) => a.group === key).map((a) => ({ path: `/articles/${a.slug}`, ...a.i18n[locale.value] })),
  })),
);
</script>

<template>
  <PublicShell>
    <main class="lp-wrap lp-narrow lp-page">
      <nav class="lp-crumbs" :aria-label="copy.articles.home">
        <RouterLink :to="to('/')">{{ copy.articles.home }}</RouterLink>
        <ChevronRight :size="14" /><span>{{ copy.articles.title }}</span>
      </nav>
      <header class="lp-page-head">
        <h1>{{ copy.articles.title }}</h1>
        <p>{{ copy.articles.sub }}</p>
      </header>

      <h2 class="lp-group">{{ copy.articles.guidesTitle }}</h2>
      <ul class="lp-list">
        <li v-for="g in guides" :key="g.path">
          <RouterLink :to="to(g.path)" class="lp-row">
            <div><h3>{{ g.title }}</h3><p>{{ g.description }}</p></div>
            <ChevronRight :size="18" />
          </RouterLink>
        </li>
      </ul>

      <template v-for="group in groups" :key="group.key">
        <h2 class="lp-group">{{ group.title }}</h2>
        <ul class="lp-list">
          <li v-for="a in group.items" :key="a.path">
            <RouterLink :to="to(a.path)" class="lp-row">
              <div><h3>{{ a.title }}</h3><p>{{ a.description }}</p></div>
              <ChevronRight :size="18" />
            </RouterLink>
          </li>
        </ul>
      </template>
    </main>
  </PublicShell>
</template>
